import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useFinance } from "./FinanceContext";
import { SEED } from "./data/seedData";

export function SettingsPage() {
  const { cur, role, userName, userEmail } = useFinance();
  return (
    <Box>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>
        System Settings
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Organisation configuration · session &amp; security
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 2 }}>
        <Box sx={{ p: 2, border: 1, borderColor: "divider", borderRadius: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5 }}>
            Organisation
          </Typography>
          <Stack spacing={1.5}>
            <TextField
              label="Company"
              value={SEED.company}
              size="small"
              slotProps={{ input: { readOnly: true } }}
            />
            <TextField
              label="Financial Year"
              value={SEED.fiscalYear}
              size="small"
              slotProps={{ input: { readOnly: true } }}
            />
            <TextField
              label="INR/USD Exchange Rate"
              value={SEED.exchangeRate}
              size="small"
              slotProps={{ input: { readOnly: true } }}
            />
            <TextField
              label="Reporting currency"
              value={cur}
              size="small"
              slotProps={{ input: { readOnly: true } }}
            />
          </Stack>
        </Box>
        <Box sx={{ p: 2, border: 1, borderColor: "divider", borderRadius: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5 }}>
            Session &amp; Security
          </Typography>
          <Stack spacing={1.5}>
            <TextField
              label="Signed in as"
              value={`${userName} (${role})`}
              size="small"
              slotProps={{ input: { readOnly: true } }}
            />
            <TextField
              label="Email"
              value={userEmail}
              size="small"
              slotProps={{ input: { readOnly: true } }}
            />
          </Stack>
          <Alert severity="info" sx={{ mt: 1.5 }}>
            Auth: Microsoft Entra ID (OIDC) + corporate-email/password · JWT access &amp; refresh
            tokens · session managed by the platform&apos;s real authentication system.
          </Alert>
        </Box>
      </Box>
      <Box sx={{ p: 2, border: 1, borderColor: "divider", borderRadius: 1, mt: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
          Data Integration
        </Typography>
        <Alert severity="info">
          Phase 1 supports Tally ERP import (JSON / XML) only. Uploads are staged, validated,
          versioned and approved before publishing — production data is never overwritten directly.
        </Alert>
      </Box>
    </Box>
  );
}
